export enum OrganigramaModalTypes {
    OPEN_ORGANIGRAMA_MODAL = '[auth] OPEN_ORGANIGRAMA_MODAL',
    CLOSE_ORGANIGRAMA_MODAL = '[auth] CLOSE_ORGANIGRAMA_MODAL',
    REACTIVE_ORGANIGRAMA_COL = '[auth] REACTIVE_ORGANIGRAMA_COL',
    UPDATE_PUESTOS = "[auth]UPDATE_PUESTOS"
}